import React from "react";
import { FormattedMessage } from "react-intl";
import Dashboard from "components/dashboard";

const NotAllowedPage = () => (
  <Dashboard>
    <h1>
      <FormattedMessage id="common.security.noAccess" />
    </h1>
  </Dashboard>
);

export default NotAllowedPage;
